import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from "@material-ui/core";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import { otherLiabilityItems } from "./objects/otherLiabilityItems";
import _ from "lodash";
import React from "react";
import { Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import { banks } from "./objects/banks";

const required = value => (value ? undefined : "Required");

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value,
    margin: "0px"
  };
};

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth>
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  
  <FormControl fullWidth style={{ bottom: "10px" }}>
    <Field {...props} />
  </FormControl>

);

const checkItem = (label, name, changeFunc) => {
  return (
    
            <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px", marginLeft: "25%"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(f, h)

                }}

              />
            </FormControl>
         
  );
};


function isInteger(value) {
  return /^\d+$/.test(value);
}

const percentage = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) >= 101 || parseInt(value, 10) < 0) {
    return "Not a valid Percentage";
  }
  return undefined;
};

const hundred = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) !== 100) {
    return "Must add up to 100";
  }

  return undefined;
};

var liability = value => {
  return (
    {
      category: "",
      description: "",
      amount: "",
      party: "",
      settleAtDeath: ""
    }
  )
}

const isEmptyOrSpaces = str => {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
};

class MarketValueLiability extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }

  addNew = () => {
    var liabilities = this.props.state.liabilities;
    liabilities.push(liability());
    this.props.addNewLiability(liabilities);
  }

  remove = (n) => {
    var liabilities = this.props.state.liabilities;
    var newLiabilities = [];
    var node = n.target;
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("removeL", "")
    console.log(i)
    liabilities.map((e,k) =>
    {
      if(e != liabilities[i])
        newLiabilities[k] = e
    })
    
    this.props.addNewLiability(newLiabilities);
  }

  changeCat = (value, name) =>
  {
    var liabilities = this.props.state.liabilities;
    var liability = name.replace("liability.category.", "")
    liabilities[liability].category = value;
    this.props.changeLiability(liabilities);
  }

  changeDesc = (value, name) =>
  {
    var liabilities = this.props.state.liabilities;
    var liability = name.replace("liability.description.", "")
    liabilities[liability].description = value;
    this.props.changeLiability(liabilities);
  }

  changeAmount = (value, name) =>
  {
    var liabilities = this.props.state.liabilities;
    var liability = name.replace("liability.amount.", "")
    liabilities[liability].amount = value;
    this.props.changeLiability(liabilities);
  }

  changeParty = (value, name) =>
  {
    var liabilities = this.props.state.liabilities;
    var liability = name.replace("liability.liableParty.", "")
    liabilities[liability].party = value;
    this.props.changeLiability(liabilities);
  }

  changeSettle = (value, name) => {
    var liabilities = this.props.state.liabilities;
    var liability = name.replace("liability.settle.", "")
    liabilities[liability].settleAtDeath = value
    this.props.changeLiability(liabilities);
  }

  render() {
    let { checkValidation } = this.props;

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%" }}>
        <Card >
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Liabilities"}
            />

            <Grid container spacing={24} className="customTableAutoGrid">
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("15em")}

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Category</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("18em")}

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                        Description
                      </Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("10em")}


                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                        Amount
                      </Typography>

                    </TableCell>

                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("12em")}

                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Liable Party</Typography>

                    </TableCell>

                    {
                      this.props.state.client != null &&
                      this.props.state.client.marital_status == "Married" &&

                      <TableCell
                        className="cellPaddingSmall"
                        style={colwidth("12em")}

                      >
                        <Typography style={{ fontSize: '16px', textAlign: "center" }}>Settle At Disability</Typography>

                      </TableCell>
                    }



                  </TableRow>

                </TableHead>
                <TableBody>

                  {this.props.state.liabilities.map((e, i) => {

                    return (
                      <TableRow>
                        

                        <TableCell>
                          <Button
                            name={"removeL" + i}
                            key = {"removeL" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          <CustomField2
                            name={"liability.category." + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            //validate={[required]}
                            options={otherLiabilityItems}
                            onChange={(e, value, t, name) => this.changeCat(value, name)}
                            
                            
                          />
                        </TableCell>

                        <CustomField
                          name={'liability.description.' + i}
                          component={FormInput}
                          checkValidation={this.props.checkValidation}
                          label={'description'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeDesc(value, name)}
                        />

                        <CustomField
                          name={'liability.amount.' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeAmount(value, name)}
                        />

                        <CustomField
                          name={"liability.liableParty." + i}
                          component={FormDropdown}
                          checkValidation={this.props.checkValidation}
                          label={''}
                          isrequired={true}
                          //validate={[required]}
                          options=
                          {[
                            { displayValue: "Please select", value: " " },
                            { displayValue: "Client", value: "client" },
                            { displayValue: "Spouse", value: "spouse" }
                          ]}
                          onChange={(e, value, t, name) => this.changeParty(value, name)}
                        />

                        {
                          this.props.state.client.marital_status == "Married" &&
                          <TableCell className="cellPaddingSmall">
                            {checkItem("", "liability.settle." + i, this.changeSettle)}
                          </TableCell>
                        }

                        


                      </TableRow>

                    )

                  })}

                  <TableRow>
                    <Table style={{ width: "10em" }}>
                      <DescriptiveRow

                        description={"Add Liability"}
                        add={() =>
                          this.addNew()
                        }

                        extraCells={10}
                      />
                    </Table>
                  </TableRow>

                </TableBody>
              </Table>

            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default MarketValueLiability;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/MarketValueLiability.jsx